import type { ComponentType } from "react";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import type { SignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import {
    isNewsSignalEvent,
    isRoleChangesSignalEvent,
} from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

export type TrackingProps = {
    onArticleLinkClick: (signalEvent: SignalEventDto) => void;
    onCompanyLinkClick: (signalEvent: SignalEventDto) => void;
    onLinkedInLinkClick: (signalEvent: SignalEventDto) => void;
    onShowDescriptionClick: () => void;
};

export default function withSignalEventsTracking<P extends TrackingProps>(
    Consumer: ComponentType<P>,
): ComponentType<Omit<P, keyof TrackingProps>> {
    return function WrappedWithSignalEventsTracking(props: P) {
        const handleOnArticleLinkClick = (signalEvent: SignalEventDto) => {
            if (isNewsSignalEvent(signalEvent)) {
                companyAnalysisTrackingService.signalEvents.trackClickOnArticleLink(signalEvent);
            }
        };

        const handleOnCompanyLinkClick = (signalEvent: SignalEventDto) => {
            if (isNewsSignalEvent(signalEvent)) {
                companyAnalysisTrackingService.signalEvents.trackClickOnCompanyLink(signalEvent);
            }
        };

        const handleOnLinkedInLinkClick = (signalEvent: SignalEventDto) => {
            if (isRoleChangesSignalEvent(signalEvent)) {
                companyAnalysisTrackingService.signalEvents.trackClickOnLinkedInLink();
            }
        };

        const handleOnShowDescriptionClick = () => {
            companyAnalysisTrackingService.signalEvents.trackClickOnShowDescription();
        };

        return (
            <Consumer
                {...props}
                onArticleLinkClick={handleOnArticleLinkClick}
                onCompanyLinkClick={handleOnCompanyLinkClick}
                onLinkedInLinkClick={handleOnLinkedInLinkClick}
                onShowDescriptionClick={handleOnShowDescriptionClick}
            />
        );
    };
}
